import styled from "styled-components";
import { COLORS, responsive } from "../../styles/constants.style";
import {
  textFieldTypographyH4Regular,
  textFieldTypographyH5SemiBold,
} from "../typography/MuiTypography.style";

export const MuiDateFieldWrapper = styled.div`
  margin-top: 5px;
  ${responsive.MOBILE`
     margin-top: 0;
  `}
  .mui-text-field {
    ${textFieldTypographyH4Regular}
    border-radius: 8px;
    color: ${COLORS.cirrus_black};
    background: ${COLORS.cirrus_black1};

    .MuiOutlinedInput-root {
      &.Mui-error .MuiOutlinedInput-notchedOutline {
        border-color: ${COLORS.cirrus_red};
        border-width: 2px;
        border-style: solid;
      }

      &:hover.Mui-error .MuiOutlinedInput-notchedOutline {
        border-color: ${COLORS.cirrus_red};
        border-style: solid;
        border-width: 2px;
      }
    }
  }

  .MuiFormHelperText-root {
    ${textFieldTypographyH5SemiBold}
    margin-top: 8px;
    line-height: 14px;
    color: ${COLORS.cirrus_red};
  }
  .Mui-error {
    margin-left: 0px;
    border-width: 1px;
    border-radius: 8px;
    .MuiOutlinedInput-notchedOutline {
      border-color: ${COLORS.cirrus_red};
      border-width: 2px;
    }
    .MuiPickersOutlinedInput-notchedOutline {
      border-width: 2px;
    }
  }

  .error-icon {
    display: flex;
    flex-direction: row;
    word-break: break-word;
  }

  .title {
    display: flex;
    align-items: baseline;
  }

  .mui-label {
    line-height: 20px;
    color: ${COLORS.cirrus_black10};
    margin-bottom: 8px;
    &.disabled {
      color: ${COLORS.cirrus_black5};
    }
  }
  .asterisk {
    color: ${COLORS.cirrus_red};
  }

  .MuiFormControl-root.MuiPickersTextField-root {
    ${responsive.MOBILE`
        width: 100%;
    `}
  }

  .MuiPickersInputBase-root {
    border-radius: 8px;
    background: ${COLORS.cirrus_black1};
    height: 48px;
    width: 180px;
    ${responsive.MOBILE`
        width: auto;
    `}
  }

  .css-iyog2t-MuiFormLabel-root-MuiInputLabel-root {
    top: -2px;
    color: ${COLORS.cirrus_black5};
  }

  .MuiPickersInputBase-root-MuiPickersOutlinedInput-root {
    position: unset;
  }
  .MuiPickersSectionList-root {
    width: 100%;
    opacity: 1; /* remove dimming */
  }

  /* Keep placeholder sections black */
  .MuiPickersInputBase-sectionContent[aria-valuetext="Empty"] {
    color: ${COLORS.cirrus_black5};
  }

  /* Make separators black only if the input is still empty */
  .MuiPickersInputBase-root:has(
      .MuiPickersInputBase-sectionContent[aria-valuetext="Empty"]
    )
    .MuiPickersInputBase-sectionAfter {
    color: ${COLORS.cirrus_black5};
  }

  /* disabled svg icon color */
  .Mui-disabled .MuiInputAdornment-root .MuiButtonBase-root svg path {
    stroke: ${COLORS.cirrus_black5};
  }

  .tooltip-container {
    position: relative;
  }

  .tooltip-wrapper {
    position: absolute;
    bottom: 2px;
  }
`;
